import camera from './camera.svg';
import lock from './lock.svg';
import store from './store.svg';

const icons = {store, lock, camera};
export default icons;
